import { render, staticRenderFns } from "./DelegatorBlock.vue?vue&type=template&id=1d9d627c&scoped=true&"
import script from "./DelegatorBlock.vue?vue&type=script&lang=js&"
export * from "./DelegatorBlock.vue?vue&type=script&lang=js&"
import style0 from "./DelegatorBlock.vue?vue&type=style&index=0&id=1d9d627c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d627c",
  null
  
)

export default component.exports